﻿import { IComponent, Component, Inject, Input, Output, Attribute, OutputArgs } from "@fiqas/angular-utils";
import { FIQAssist } from "../../app";
import { Application } from "../../components/application"
import { DropdownEntry } from "../../controls/dropdownbox";
import { IDisposable } from "../../interfaces/general";
import { TranslationService } from "../../services/TranslationService";
import { CaseType } from "../../models/serviceCase";

@Component({
    module: FIQAssist,
    selector: "casetypedropdownbox",
    template: `
            <dropdownbox
                value-submit="$ctrl.passValueSubmit(selected)"
                read-only="$ctrl.readOnly" translate="true" multiselecttext="'MULTIPLE_ENVIRONMENTS_SELECTED'"
                multiselect="$ctrl.multiselect" hint="'Please choose an priority'" show-clear="{{$ctrl.showClear}}"
                selected="$ctrl._caseTypes" items="$ctrl.items" onselectionchanged="$ctrl.casetypesselected(selected)"></dropdownbox>`
})
class CaseTypeDropdownBox implements IComponent {
    @Input() public readOnly: boolean;
    private _caseTypes: { key: CaseType, text: string }[];
    private initialized: boolean = false;
    private ALL_CASETYPES_SELECTED = "ALL_CASETYPES_SELECTED"
    private MULTIPLE_CASETYPES_SELECTED = "MULTIPLE_CASETYPES_SELECTED"

    constructor(
        @Inject('$timeout') private $timeout: ng.ITimeoutService,
        @Inject() private translationService: TranslationService
    ) { }

    $onInit() {
        this.initialized = true;
        this.items = <{ key: CaseType, text: string }[]>[
            { key: 'bug', text: 'BUG' },
            { key: 'request', text: 'REQUEST' },
            //{ key: 'support', text: 'SUPPORT' },
        ].sort((a, b) => a.key > b.key ? 1 : -1);
        this.translateItems();
    }

    private _multiselect:boolean;
    @Attribute() set multiselect(val: boolean | string){
        this._multiselect = val === "true" || val === true;
    }
    get multiselect(){
        return this._multiselect;
    }

    private async translateItems() {
        await this.translationService.onLoaded;
        this.items = this.items.map(i => { i.text = this.translationService.Translate(i.text); return i; }).sort((a, b) => a.text > b.text ? 1 : -1);
    }

    @Input()
    public get casetypes(): { key: CaseType, text: string }[] {
        return this._caseTypes;
    }
    public set casetypes(casetypes: { key: CaseType, text: string }[]) {
        this._caseTypes = casetypes;
    }
    private _showClear;
    @Attribute() public get showClear() {
        return this._showClear;
    }
    public set showClear(val: boolean | string) {
        this._showClear = val === true || val === "true";
    }
    private items: { key: CaseType, text: string }[];


    @Output() public onCasetypesChanged: OutputArgs<{ casetypes: any[] }>;
    public casetypesselected(selected: any[]) {
        this.casetypes = selected;
        this.onCasetypesChanged({ casetypes: this.casetypes });
    }
    @Output() public valueSubmit: OutputArgs<{ casetypes: any[] }>;
    public passValueSubmit(selected: any[]) {
        this.casetypes = selected;
        if (this.valueSubmit) this.valueSubmit({ casetypes: this.casetypes });
    }
}
